import { Component, Input } from "@angular/core";
import { ISegment } from "libraries/service/resources/airTrip/IGetAirTripQuotes";

@Component({
    selector: 'segment-list',
    template: `
        <div class="segment-list"
             *ngIf="segmentList"
             [class.only-one]="segmentList.length === 1"
             [class.two]="segmentList.length === 2"
             [class.several]="segmentList.length > 2">
            <div *ngFor="let segment of segmentList;trackBy: tracker"
                 class="segment-list-wrapper">
                <segment [segmentItem]="segment" type="sectorListTitle"></segment>

                <div class="sector-list e2e-time" *ngFor=" let sector of segment.sector;trackBy: tracker">
                    <sector [sectorItem]="sector"></sector>
                </div>
            </div>
        </div>`,
    styleUrls: ['./segment-list.scss'],
})
export class SegmentListComponent {
    @Input()
    public segmentList: ISegment[];

    public tracker(index: number): number {
        return index;
    }
}